<script setup>
import { ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const props = defineProps({
  integration: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const customAppRef = ref({});
const dialogRef = ref(null);
const uiFlags = getters['integrations/getUIFlags'];

const handleDialogConfirm = async () => {
  try {
    const hookPayload = {
      hookId: customAppRef.value.id,
      appId: props.integration.id,
    };
    await store.dispatch('integrations/deleteHook', hookPayload);
    useAlert(t('WGPT_CUSTOM_APPS.DELETE.API.SUCCESS_MESSAGE'));

    dialogRef.value?.close();
  } catch (error) {
    const errorMessage =
      error?.message || t('WGPT_CUSTOM_APPS.DELETE.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const open = customApp => {
  customAppRef.value = customApp;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_CUSTOM_APPS.DELETE.CONFIRM.TITLE')"
    :description="
      t('WGPT_CUSTOM_APPS.DELETE.CONFIRM.MESSAGE', {
        webhookURL: customAppRef.name,
      })
    "
    :confirm-button-label="t('WGPT_CUSTOM_APPS.DELETE.CONFIRM.YES')"
    :cancel-button-label="t('WGPT_CUSTOM_APPS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeletingHook"
    :disable-confirm-button="uiFlags.isDeletingHook"
    @confirm="handleDialogConfirm"
  />
</template>
